<template>
    <div class="asideDescription">

        <h3>{{ destination.baseName }}, {{ destination.countryName }}</h3>
        <p></p>
        <div v-html="destination.summary">
        </div>

        <p></p>

        <div class="shortcuts" v-if="transformedForecastDays.current && transformedForecastDays.current.degrees">
            <ul>

                <li id="wCurrent" class="group">

                    <h2 class="noMargin">{{ __('messages.current_conditions') }}</h2>
                    <strong>{{ __(`weather.weather${transformedForecastDays.current.descriptionCode}`) }}</strong>
                    <div class="group">
                        <img :src="`https://3.cdnpt.com/images/weather-icons/${transformedForecastDays.current.descriptionCode}.png`"
                            width="61" height="61"
                            :alt="__(`weather.weather${transformedForecastDays.current.descriptionCode}`)" class="wImg">
                        <div class="wTemp">
                            {{ transformedForecastDays.current.degrees }}{{ __('messages.code_weather') }}
                        </div>
                        <div>
                            {{ transformedForecastDays.today }}
                        </div>
                    </div>
                </li>

                <li v-for="infoDay in transformedForecastDays.infoDays" class="forecast">
                    <div class="wImg">
                        <div><strong>{{ infoDay.dayInfo }}</strong></div>

                        <img :src="infoDay.imgDay" :alt="__(`weather.weather${infoDay.descriptionCode}`)" width="40"
                            height="40" :title="__(`weather.weather${infoDay.descriptionCode}`)">
                        <div class="fdesc">{{ infoDay.meatherMessage }}</div>
                        <div class="group">
                            <div class="floatleft">
                                <div class="tiny caps">{{ __('messages.min') }}</div>
                                <div>{{ infoDay.degreesMin }}{{ __('messages.code_weather') }}</div>
                            </div>
                            <div>
                                <div class="tiny caps">{{ __('messages.max') }}</div>
                                <div>{{ infoDay.degreesMax }}{{ __('messages.code_weather') }}</div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <p class="source"
            v-if="destination.weather.isActive && destination.weather.location && destination.weather.location.length">
            {{ __('messages.full_forecast') }}:
            <a class="link link--xs" :href="`http://www.worldweatheronline.com/weather.aspx?q=${destination.weather.location}`"
                title="Free local weather content provider" rel="nofollow">World Weather Online</a>
        </p>


    </div>
</template>


<script>
const site = window.__pt.settings.site;

export default {
    props: {
        forecastDays: Array,
        destination: Object,
    },
    methods: {

    },
    computed: {
        transformedForecastDays() {

            const daysArray = this.forecastDays ? this.forecastDays.filter(x => !x.current) : [];

            let day = 1;
            const baseUrl = 'https://3.cdnpt.com/images/weather-icons/';

            const infoDays = daysArray.map(item => {
                return {
                    ...item,
                    dayInfo: window.moment().locale(site.culture).add(day++, 'days').format('dddd DD'),
                    meatherMessage: this.__(`weather.weather${item.descriptionCode}`),
                    imgDay: `${baseUrl}${item.descriptionCode}.png`
                };
            });

            const currentDay = (this.forecastDays && this.forecastDays.filter(x => x.current)[0]) || {};

            return {
                ...this.forecastDays,
                current: currentDay,
                description: `Forecast for ${this.forecastDays?.description || ''}`,
                today: moment().locale(site.culture).format('dddd DD MMMM'),
                infoDays
            };
        }
    },
    data() {
        return {

        };
    },


};
</script>